import { useCallback, useState } from 'react';
import { Navigate, useNavigate,useParams ,useSearchParams } from 'react-router-dom';
import Footer from '../../components/Footer';
import CTAs from '../../components/CTAs';
import PasswordInputFieldRegister from '../../components/PasswordInputFieldRegister';

const NewPassword = () => {
    const navigate = useNavigate();
   const [searchParams] = useSearchParams();
    const userId = searchParams.get('userId');
    const token = searchParams.get('token');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const API_URL = process.env.REACT_APP_API_URL;
  	
  	const onCTAsResetPassword = useCallback(async () => {
        setError('');
        setSuccess('');

        if (!password || !confirmPassword) {
            setError('Please fill in both password fields.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        if (password.length < 8) {
            setError('Password must be at least 8 characters.');
            return;
        }

        try {
            const res = await fetch(`${API_URL}/api/users/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token,
                    userId, // ✅ include userId
                    newPassword: password,
                }),
                });
            const data = await res.json();

            if (!res.ok) {
            setError(data.message || 'Something went wrong.');
            } else {
            setSuccess('Password reset successful! Redirecting to login...');
            setTimeout(() => navigate('/login'), 2000);
            }
        } catch (err) {
            setError('Network error. Please try again.');
        }
        }, [password, confirmPassword, token, navigate]);


    const onCTAslogin = useCallback(() => {
        navigate('/login')
    })

    const handlePasswordChange = (value) => {
        setPassword(value);
    };
  	
  	return (
    		<div className="w-full relative bg-white min-h-screen overflow-visible text-center text-sm text-neutrals-neutral-900 font-open-sans-ff-meta">
                {/* Main */}
      			<div className="w-full absolute top-[calc(50%_-_293px)] flex flex-col items-center justify-start gap-10 px- md:px-4 lg:px-24 box-border">
                    <div className="self-stretch flex flex-col items-center justify-start gap-6 text-9xl">
                        <div className="w-12 shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border h-12 flex flex-row items-center justify-center p-2.5 border-[1px] border-solid border-neutrals-neutral-100">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M6 10V8c0-3.31 1-6 6-6s6 2.69 6 6v2M17 22H7c-4 0-5-1-5-5v-2c0-4 1-5 5-5h10c4 0 5 1 5 5v2c0 4-1 5-5 5Z" stroke="#2d404e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.996 16h.01M11.995 16h.01M7.995 16h.008" stroke="#2d404e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </div>
                        <div className="self-stretch flex flex-col items-center justify-start gap-2.5">
                            <b className="self-stretch relative">Set new password</b>
                            <div className="self-stretch relative text-base text-neutrals-neutral-300">
                                <p className="m-0">Your new password must be different to</p>
                                <p className="m-0">previously used passwords.</p>
                            </div>
                        </div>
                    </div>
                    <div className="self-stretch flex flex-col items-center justify-start text-left">
                        <div className="self-stretch flex flex-col items-center justify-start gap-5">
                            <PasswordInputFieldRegister
                                title="Password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                validationMessage="Please provide your password."
                                iconColor="#D93C3D"
                                iconSize="20px"
                                />

                                <PasswordInputFieldRegister
                                title="Confirm password"
                                placeholder="Re-enter your password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                validationMessage="Please confirm your password."
                                iconColor="#D93C3D"
                                iconSize="20px"
                                />

                            
                            
                        </div>
                    </div>
                    <CTAs
                        type="Primarybtn"
                        text="Reset password"
                        textColor="text-neutrals-neutral-50"
                        bgColor="bg-primary-primary-500"
                        borderColor="border-primary-primary-500"
                         width="w-[330px] md:w-[400px]"
                         position="relative"
                         onClick={onCTAsResetPassword}
                    />
                    <div className="self-stretch flex flex-row items-start justify-center gap-1.5 cursor-pointer" onClick={onCTAslogin}>
                        <div className="w-5 relative h-5">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"><path stroke="#2d404e" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M9.57 5.93L3.5 12l6.07 6.07M20.5 12H3.67"></path></svg>
                        </div>
                        <div className="flex flex-row items-start justify-center">
                            <div className="relative font-semibold">Back to login</div>
                        </div>
                    </div>
                    {/* Footer */}
                    <Footer/>
      			</div>
      			
    		</div>);
};

export default NewPassword;